import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="bmp" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#479d90"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#1c6258"
          />
        </g>
        <path
          id="Контур_812"
          data-name="Контур 812"
          d="M-6.255-.266v-4h1.437a2.035,2.035,0,0,1,1.174.283.942.942,0,0,1,.4.821.952.952,0,0,1-.143.53.832.832,0,0,1-.42.324A.843.843,0,0,1-3.324-2a.9.9,0,0,1,.168.549,1.059,1.059,0,0,1-.372.883,1.771,1.771,0,0,1-1.1.3Zm.964-1.7v.959h.632a.6.6,0,0,0,.4-.12.418.418,0,0,0,.14-.337.443.443,0,0,0-.5-.5Zm0-.632h.5a.716.716,0,0,0,.451-.115A.409.409,0,0,0-4.2-3.046a.429.429,0,0,0-.146-.364.781.781,0,0,0-.47-.111h-.473ZM-1.3-4.266-.41-1.483.48-4.266H1.749v4H.782V-1.2L.876-3.112-.091-.266H-.729L-1.7-3.115-1.605-1.2v.934h-.964v-4ZM3.382-1.623V-.266H2.418v-4h1.6a1.859,1.859,0,0,1,.812.169,1.273,1.273,0,0,1,.547.481,1.313,1.313,0,0,1,.194.707,1.157,1.157,0,0,1-.419.935A1.738,1.738,0,0,1,4-1.623Zm0-.745h.632a.6.6,0,0,0,.427-.14.521.521,0,0,0,.147-.4.643.643,0,0,0-.151-.448.535.535,0,0,0-.412-.17H3.382Z"
          transform="translate(575.625 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
